/**
 * 招待メールと送信記録の状態の表示(設計書 §5.2・§6.5。RC1 実装レビュー L-2)。
 * 値はサーバーの `app/reception/contact.py`(`INVITE_*` と `N_*`)と同じ。
 * `tests/reception-mail-status.test.mjs` が両方を突き合わせる。
 *
 * 「受理」は SMTP サーバーが受け取ったという意味で、受信箱に届いたことではない。
 * 「結果不明」は本文を送った後に応答が無かったもので、届いている可能性がある。
 */

export const INVITE_STATUS: Record<string, string> = {
  pending: "送信待ち",
  accepted: "SMTP 受理",
  unknown: "結果不明・再試行中",
  unknown_final: "結果不明・打切り",
  failed: "送信失敗",
  skipped: "送らない",
};

/** 状態の補足(画面ではマウスを載せると出る)。再送するかの判断に要るものだけ。 */
export const INVITE_STATUS_HELP: Record<string, string> = {
  accepted: "送信先のメールサーバーが受け取った。受信箱に届いたかは分からない",
  unknown: "送った後に応答が無かった。届いている可能性がある。自動で再試行している",
  unknown_final:
    "応答が無いまま再試行を打ち切った。届いている可能性があるので、再送する前に来訪者に確かめる",
  failed: "送信先のメールサーバーに断られた。宛先を確かめる",
};

export const NOTIFICATION_STATUS: Record<string, string> = {
  pending: "送信待ち",
  retry_wait: "再試行待ち",
  accepted: "SMTP 受理",
  failed: "送信失敗",
  unknown_final: "結果不明・打切り",
  cancelled: "取消",
  expired: "期限切れ",
};
